module.exports = __webpack_public_path__ + "img/babylon-Unselected.2e9d5c18.webp";